import { UiEditorComponent } from '../../components/formEditor/uiEditor/uiEditor.component';
import { FC, PropsWithChildren } from 'react';
import { studyNoteBuilderControlsResolver } from 'src/features/generalForms/studyNoteForms/builderResolver';
import { useStudyNoteSelectors } from 'src/features/generalForms/studyNoteForms/selectors';
import { GeneralFormBuilder } from 'src/features/generalForms/builder/generalFormBuilder';
import { CommonLayerItem } from 'src/components/formEditor/toolbox/components/layerItem';
import { FormBuilderBufferContextProvider } from 'src/features/generalForms/context/formBuilderBuffer.provider';
import { useFormTypeSelector } from './formTypeProvider';

export const EMPTY_LAYOUT = {
  ROOT: {
    type: {
      resolvedName: 'RootContainer',
    },
    isCanvas: true,
    props: {},
    displayName: 'ROOT',
    custom: {
      width: 760,
      paddingBottom: 16,
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 16,
      height: 'fit-content',
      gap: 12,
    },
    hidden: false,
    nodes: [],
    linkedNodes: {},
  },
};

export const PatientFormBuilderPage = () => {
  return (
    <FormBuilderBufferContextProvider>
      <UiEditorComponent isInDesignerMode={true} />
    </FormBuilderBufferContextProvider>
  );
};

export const GeneralFormBuilderPage = () => {
  const selectors = useStudyNoteSelectors();
  const { builderProps, createConfigModal, configSelectorComponent } = useFormTypeSelector();

  return (
    <>
      <GeneralFormBuilder
        resolver={studyNoteBuilderControlsResolver}
        layerItem={StudyNoteLayerItem}
        selectors={selectors}
        configSelectorComponent={configSelectorComponent}
        {...builderProps}
      />
      {createConfigModal}
    </>
  );
};

const StudyNoteLayerItem: FC<PropsWithChildren> = ({ children }) => {
  const selectors = useStudyNoteSelectors();
  return <CommonLayerItem selectors={selectors}>{children}</CommonLayerItem>;
};
